<template>
    <div class="main">
        <div class="mainTop">
            <!-- <div class="leftImg">
        <img src="https://img01.yzcdn.cn/vant/apple-1.jpg" alt="">
      </div> -->
            <div class="rightFont">
                <div class="rightTil" v-if="userinfo && userinfo.name">
                    {{ userinfo.name }}
                </div>
                <div class="rightCom" v-if="userinfo && userinfo.mainOrg">
                    {{ userinfo.mainOrg }}
                </div>
            </div>
        </div>
        <div class="mainCenter">
            <div class="cardBox">
                <div class="card leftCard">
                    <div class="leftCardFont">{{ (userNum && userNum.meals) || 0 }}</div>
                    <div class="topTi">本月就餐数</div>
                </div>
                <div class="card rightCard">
                    <div class="rightCardFont">
                        {{ (userNum && userNum.reservations) || 0 }}
                    </div>
                    <div class="topTi">本月预约次数</div>
                </div>
                <div class="card rightCard">
                    <div class="centerCardFont" v-if="userNum && userNum.balanceDeducted">
                        ￥-{{ userNum.balanceDeducted }}
                    </div>
                    <div class="centerCardFont" v-else>0</div>
                    <div class="topTi">本月预扣总金额</div>
                </div>
            </div>
        </div>
        <div class="mainBom">
            <ul>
                <li @click="changeToOrder">
                    <van-cell is-link>
                        <template #title>
                            <img class="mainIcon" src="../assets/mineIcon1.png" alt="" />
                            <span class="bomTil">就餐记录</span>
                        </template>
                    </van-cell>
                </li>
                <li @click="changeToPoint">
                    <van-cell is-link>
                        <template #title>
                            <img class="mainIcon" src="../assets/mineIcon2.png" alt="" />
                            <span class="bomTil">我的预约</span>
                        </template>
                    </van-cell>
                </li>
                <li @click="changeToCollection">
                    <van-cell is-link>
                        <template #title>
                            <img class="mainIcon" src="../assets/mineIcon4.png" alt="" />
                            <span class="bomTil">我的收藏</span>
                        </template>
                    </van-cell>
                </li>
                <li @click="changeToPath">
                    <van-cell is-link>
                        <template #title>
                            <img class="mainIcon" src="../assets/mineIcon3.png" alt="" />
                            <span class="bomTil">问题库</span>
                        </template>
                    </van-cell>
                </li>
            </ul>
        </div>
        <div class="scanBtn bottom" @click="messageNotification">
            <img src="../assets/news.png" alt="" />
        </div>
        <div class="scanBtn" @click="scanFunc">
            <img src="../assets/scanBtn.png" alt="" />
        </div>
        <van-popup v-model="showFalse" round closeable>
            <div class="falseCont">
                <div class="fTopImg"><img src="../assets/scanFalse.png" alt="" /></div>
                <div class="fTil">扫码失败</div>
                <div class="fText">{{ falseCont }}</div>
            </div>
        </van-popup>
        <van-popup v-model="showTrue" round closeable>
            <div class="trueCont">
                <div class="tTil">确认支付</div>
                <div class="tCenter">
                    <span class="price">{{ scanAllText.mealFee }}</span>
                    <!-- 2022.8.22 晚六点修改 -->
                    <!-- <span class="price" v-if="scanAllText.canteenType=='食堂'">-15</span> -->
                    <!-- <span class="price" v-if="scanAllText.canteenType=='廉政灶'">-30</span> -->
                    元就餐费
                </div>
                <div class="tUser">
                    <span class="tname" v-if="scanAllText && scanAllText.workerName">{{
                    scanAllText.workerName
                    }}</span>在<span class="tdate" v-if="nowDate">{{ nowDate }}</span>
                </div>
                <div class="tBom">
                    即将支付<span class="taddress" v-if="scanAllText && scanAllText.canteenName">{{ scanAllText.canteenName
                    }}</span>
                </div>
                <van-cell v-if="scanAllText && scanAllText.businessUnitList.length > 1" value-class="van-ellipsis"
                    title="出差单位：" is-link :value="companyText" @click="showCompanuBox" />
                <div class="tBomBtnBox">
                    <div class="tBtnLeft" @click="showTrue = false">撤回</div>
                    <div class="tBtnRight" @click="getScanText2">确定</div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="showCompanu" round position="bottom">
            <van-picker show-toolbar :columns="companycolumns" @cancel="showCompanu = false"
                @confirm="onConfirmCompany" />
        </van-popup>
    </div>
</template>

<script>
import qs from "qs";
import Vue from "vue";
import { Cell, CellGroup, Dialog } from "vant";
import { Toast } from "vant";
import { addBaseAplus } from "../utils/zzdmd.js";
Vue.use(Toast);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Dialog);
export default {
    name: "mine",
    data() {
        return {
            userinfo: "",
            userNum: "",
            showFalse: false,
            falseCont: "",
            showTrue: false,
            scanAllText: "",
            nowDate: "",
            scanText: "",
            showCompanu: false,
            companycolumns: [],
            companyId: 0,
            companyText: "请选择",
            timers: false,
        };
    },
    created() {
        this.getUserInfo();
        this.getUserNum();
        this.nowDate = this.getnow();
    },
    mounted() {
        addBaseAplus(this.$route);
    },
    activated() {
        this.getUserNum();
        this.nowDate = this.getnow();
    },
    methods: {
        showCompanuBox() {
            this.companycolumns = [];
            if (this.scanAllText && this.scanAllText.businessUnitList.length > 1) {
                this.scanAllText.businessUnitList.map((item, index) => {
                    this.companycolumns.push({
                        text: item.olName,
                        value: item.id,
                    });
                });
            }
            this.showCompanu = true;
        },
        onConfirmCompany(e) {
            this.companyId = e.value;
            this.companyText = e.text;
            this.showCompanu = false;
        },
        getUserInfo() {
            dd.getLoginUser()
                .then((res) => {
                    this.userinfo = res;
                })
                .catch((err) => {
                    // Dialog.alert({
                    //   title: '提示',
                    //   message: '获取用户信息失败，请重新登录',
                    //   confirmButtonColor:'#3B87F5',
                    //   cancelButtonColor:'#666666'
                    // }).then(() => {
                    //   // on close
                    //   dd.closePage()
                    // });
                });
        },
        getUserNum() {
            let param = {
                WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
                // WorkerID:11
            };
            console.log(param);
            this.$post("api/User/MealsDndReservations", qs.stringify(param), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }).then((res) => {
                if (res.code == 1000) {
                    this.userNum = res.data;
                }
            });
        },
        changeToPath() {
            this.$router.push({ path: "/problem" });
        },
        changeToPoint() {
            this.$router.push({ path: "/appoint" });
        },
        changeToOrder() {
            this.$router.push({ path: "/order" });
        },
        changeToCollection() {
            this.$router.push({ path: "/collection" });
        },
        getUrlKey1: function (name, url) {
            return (
                decodeURIComponent(
                    (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                        url
                    ) || [, ""])[1].replace(/\+/g, "%20")
                ) || null
            );
        },
        scanFunc() {
            let _this = this;
            this.$post("api/Dingding/GetJSAPOTicket")
                .then((res) => {
                    if (res.code == 1000) {
                        let ticket = res.data.content.data.accessToken;
                        //01 获取鉴权码
                        // 02  鉴权
                        dd.authConfig({
                            ticket: ticket,
                            jsApiList: ["scan"],
                        })
                            .then((res) => {
                                // 03 判断鉴权结果后，使用获取地理位置
                                dd.scan({
                                    type: "qr",
                                }).then((res) => {
                                    this.getScanText(this.getUrlKey1("qrcode", res.text));
                                });
                            })
                            .catch((err) => {
                                Dialog.alert({
                                    title: "提示",
                                    message: "打开扫码失败",
                                }).then(() => {
                                    // on close
                                });
                            });
                    }
                })
                .catch((err) => {
                    Dialog.alert({
                        title: "提示",
                        message: "打开扫码失败",
                    }).then(() => {
                        // on close
                    });
                });
        },
        // 消息通知
        messageNotification() {
            this.$router.push({ path: "/news" });
        },
        getScanText(text) {
            this.scanText = text;
            let param = {
                QRCode: text,
                WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
                // WorkerID:102061,
                Probe: false,
            };
            this.$post("api/Canteen/Estimate", qs.stringify(param), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }).then((res) => {
                if (res.code == 1000) {
                    this.scanAllText = res.data;
                    if (res.data.businessUnitList.length == 1) {
                        this.companyId = res.data.businessUnitList[0].id;
                    }
                    this.showTrue = true;
                } else {
                    this.falseCont = res.msg || res.message;
                    this.showFalse = true;
                }
            });
        },
        getScanText2() {
            if (this.timers) {
                setTimeout(() => {
                    this.timers = false;
                }, 1000);
                return;
            }
            this.timers = true;
            if (this.scanAllText && this.scanAllText.businessUnitList.length > 1) {
                if (!this.companyId) {
                    Toast({
                        message: "请先选择出差单位",
                        position: "bottom",
                    });
                    return;
                }
            }
            this.showTrue = false;
            let param = {
                QRCode: this.scanText,
                WorkerID: JSON.parse(sessionStorage.getItem("userData")).workerID,
                // WorkerID:102061,
                Probe: true,
                Longitude: sessionStorage.getItem("userLon"),
                Latitude: sessionStorage.getItem("userLat"),
                BusinessUnit: this.companyId || 0,
            };
            this.$post("api/Canteen/Estimate", qs.stringify(param), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            }).then((res) => {
                if (res.code == 1000) {
                    this.$router.push({
                        path: "/scanSucess",
                        query: {
                            oid: res.data.orderID,
                            cid: res.data.canteenID,
                            mealFee: res.data.mealFee,
                        },
                    });
                } else {
                    this.falseCont = res.msg || res.message;
                    this.showFalse = true;
                }
            });
        },
        getnow(dates) {
            var mynow = dates ? new Date(dates) : new Date(); //默认的获取的是当前时间
            //通过调用日期对象的方法来重新获取当前的日期时间
            //mynow.setFullYear(2016);
            var year = mynow.getFullYear(); //获取年
            var month =
                mynow.getMonth() + 1 < 10
                    ? "0" + (mynow.getMonth() + 1)
                    : mynow.getMonth() + 1; //获取月
            var day = mynow.getDate() < 10 ? "0" + mynow.getDate() : mynow.getDate(); //获取日
            var hour =
                mynow.getHours() < 10 ? "0" + mynow.getHours() : mynow.getHours(); //获取小时
            var minute =
                mynow.getMinutes() < 10 ? "0" + mynow.getMinutes() : mynow.getMinutes(); //获取分钟
            // var second =mynow.getSeconds();//获取秒
            var strdate = year + "-" + month + "-" + day + " " + hour + ":" + minute;
            return strdate;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
    background: #f2f2f2;
    min-height: 100vh;
    position: relative;
}

.mainTop {
    width: 100%;
    height: 170px;
    background: linear-gradient(0deg, #50afff, #0683ed);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 0 12px;
}

.leftImg {
    width: 60px;
    height: 60px;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
}

.leftImg>img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.rightFont {
    width: calc(100% - 70px);
}

.rightTil {
    font-size: 18px;
    font-weight: 500;
    color: #fffffe;
    margin: 10px 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.rightCom {
    font-size: 14px;
    font-weight: 500;
    color: #fffefd;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.mainCenter {
    width: 100%;
    margin-top: -35px;
    box-sizing: border-box;
    padding: 0 12px;
}

.cardBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(0deg, #f2f2f2, #ffeddc);
    box-shadow: 0px 1px 4px 0px rgba(4, 0, 0, 0.16);
    border-radius: 5px;
}

.card {
    box-sizing: border-box;
    padding: 15px 14px;
    text-align: center;
}

/* .leftCard {
  background-image: linear-gradient(to right, #fff, rgba(234, 99, 99, 0.3));
}
.rightCard {
  background-image: linear-gradient(to right, #fff, rgba(255, 144, 35, 0.3));
} */
.topTi {
    font-size: 12px;
    font-weight: 500;
    color: #333333;
    margin-top: 10px;
}

.leftCardFont {
    font-size: 24px;
    font-weight: bold;
    color: #3b87f5;
}

.rightCardFont {
    font-size: 24px;
    font-weight: bold;
    color: #ff9023;
}

.centerCardFont {
    font-size: 24px;
    font-weight: bold;
    color: #ea6363;
}

.mainIcon {
    width: 15px;
    height: 15px;
    vertical-align: text-top;
}

.bomTil {
    font-size: 14px;
    font-weight: bold;
    color: #000000;
    margin-left: 10px;
}

.mainBom {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 12px;
}

.mainBom>ul>li {
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 1px 4px 0px rgba(4, 0, 0, 0.16);
    border-radius: 5px;
    overflow: hidden;
    margin-bottom: 12px;
}

.van-cell {
    padding: 14px 16px;
}

.scanBtn {
    width: 58px;
    height: 58px;
    position: absolute;
    bottom: 72px;
    right: 8px;
    z-index: 1;
}

.bottom {
    bottom: 148px;
}

.scanBtn>img {
    width: 100%;
    height: 100%;
}

.falseCont {
    box-sizing: border-box;
    padding: 50px 42px;
    background-color: #fff;
    border-radius: 5px;
    width: 80vw;
    text-align: center;
}

.fTopImg {
    width: 44px;
    height: 44px;
    margin: 0 auto;
}

.fTopImg>img {
    width: 100%;
    height: 100%;
}

.fTil {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-top: 15px;
}

.fText {
    font-size: 12px;
    font-weight: 500;
    color: #666666;
    margin-top: 10px;
}

.trueCont {
    box-sizing: border-box;
    padding: 12px 28px;
    background-color: #fff;
    border-radius: 5px;
    width: 80vw;
    text-align: center;
}

.tTil {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
}

.tCenter {
    margin-top: 24px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
}

.price {
    font-size: 28px !important;
    color: #ea6363 !important;
}

.tUser {
    margin-top: 12px;
    font-size: 14px;
    color: #333333;
}

.tdate {
    color: #3b87f5 !important;
}

.tBom {
    margin-top: 4px;
    font-size: 14px;
    color: #333333;
}

.tBomBtnBox {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 15px;
}

.tBtnLeft {
    padding: 5px 22px;
    border-radius: 4px;
    border: 1px solid #3b87f5;
    font-size: 16px;
    color: #3b87f5;
}

.tBtnRight {
    padding: 5px 22px;
    border-radius: 4px;
    font-size: 16px;
    color: #fff;
    background: #3b87f5;
}
</style>



// WEBPACK FOOTER //
// src/page/mine.vue